import { notFound, usePathname } from 'next/navigation';
import { FC, useState } from 'react';
import { RedocStandalone } from 'redoc';

import { ArticlePageProps } from '@/pages/Article/types';
import { isEmpty } from '@/utils/common';
import { getSpecPath } from '@/utils/routes';

export function withRedoc<P extends ArticlePageProps>(Component: React.ComponentType<P>): FC<P> {
  return (props: P) => {
    const [fetchConfigError, setFetchConfigError] = useState<Error | undefined>(undefined);
    const { pageData } = props;
    const pathName = usePathname();
    const specPathToNodeServer = getSpecPath(pageData, pathName);

    if (fetchConfigError) {
      return notFound();
    }

    if (!isEmpty(specPathToNodeServer)) {
      return <RedocStandalone onLoaded={setFetchConfigError} specUrl={specPathToNodeServer} />;
    }

    return <Component {...props} />;
  };
}
